var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"mt-4",attrs:{"data-testid":_vm.testid,"color":"button","block":"","x-large":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(this.icon))]),_c('span',[_vm._v(_vm._s(this.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }